import React from "react";
import "./contactUs.layout.sass";
import {
  Col,
  Form,
  Row,
  FormGroup,
  FormControl,
  Button,
  ControlLabel,
  Schema,
  Alert,
} from "rsuite";
import Axios from "axios";
import contactHeader from "../../assets/image/contact-header.png";
import contactMid from "../../assets/image/contact-mid.png";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import { Setting } from "../../setting";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { css } from "@emotion/react";
import { selectBaseInfo } from "../../redux/site/site.selector";
import GridLoader from "react-spinners/GridLoader";

const { StringType, NumberType } = Schema.Types;

class ContactUsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValue: {
        full_name: "",
        mobile: "",
        msg: "",
      },
    };
  }

  render() {
    const { BaseInfo } = this.props;
    if (BaseInfo) {
      let base = JSON.parse(BaseInfo[0].baseInfo);
    }
    const model = Schema.Model({
      full_name: StringType().isRequired("لطفا نام خود را وارد کنید"),
      mobile: NumberType().isRequired("لطفا شماره تلفن خود را وارد کنید"),
      msg: StringType().isRequired("پیام خود را بنویسید"),
    });

    const handleSubmit = (value) => {
      if (value) {
        Axios.post(
          `${Setting.apiUrl}api/contactUs/add`,
          {
            full_name: this.state.formValue.full_name,
            mobile: this.state.formValue.mobile,
            msg: this.state.formValue.msg,
          },
          { Accept: "application.json", contentType: "application.json" }
        ).then((res) => {
          if (res.status === 200) {
            Alert.success("فرم شما با موفقیت ارسال شد", 3000);
            this.setState({
              formValue: {
                full_name: "",
                mobile: "",
                msg: "",
              },
            });
          } else {
            Alert.error(
              "خطایی در ارسال فرم به وجود آمده، لطفا مجددا تلاش فرمایید",
              3000
            );
          }
        });
      } else {
        Alert.error("لطفا فرم را بادقت تکمیل نمایید", 3000);
      }
    };
    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
      position: relative;
    `;
    return (
      // HEADER
      <div className="contact-us-page">
        {/* SUB HEADER */}
        <SubHeaderComponent imageSrc={contactHeader} pageName={"تماس با ما"} />
        {/*  LIST ITEM  */}
        <div className="need-max-width">
          <div className="contact-us-content">
            <Row>
              <Col md={12} sm={24} className="col-justify col-justify1">
                <img src={contactMid} alt="gps pin Xitonix" />
              </Col>
              <Col md={12} sm={24} className="col-justify">
                <div className="contact-page-ul-div">
                  {BaseInfo ? (
                    <ul className="contact-page-ul">
                      {JSON.parse(BaseInfo[0].contactInfo).map((x, i) => (
                        <li key={i}>
                          <span>
                            {x.key} : {x.value}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="contact-page-loading-div">
                      <GridLoader
                        css={override}
                        size={15}
                        margin={8}
                        color="#FF8F3C"
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            {/*  FORM  */}
            <Row className="contact-form-div">
              <Col xs={24}>
                <ul className="form-one-ui">
                  <li>
                    <span>فرم ارتباط</span>
                  </li>
                </ul>
                <Form
                  id="contactUsForm"
                  model={model}
                  className="contact-page-form-inputs"
                  formValue={this.state.formValue}
                  onChange={(value) => this.setState({ formValue: value })}
                  onSubmit={(value) => handleSubmit(value)}
                >
                  <FormGroup>
                    <ControlLabel className="contact-form-label">
                      نام و نام خانوادگی
                    </ControlLabel>
                    <FormControl
                      className="contact-form-input"
                      size="lg"
                      name="full_name"
                      placeholder="اجباری"
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel className="contact-form-label">
                      تلفن همراه
                    </ControlLabel>
                    <FormControl
                      className="contact-form-input"
                      size="lg"
                      name="mobile"
                      placeholder="اجباری"
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel className="contact-form-label">
                      پیام شما
                    </ControlLabel>
                    <FormControl
                      className="contact-form-input"
                      size="lg"
                      componentClass="textarea"
                      row={3}
                      name="msg"
                      placeholder="اجباری"
                    />
                  </FormGroup>
                  <Button type="submit" className="contact-page-submit-btn">
                    ارسال
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  BaseInfo: selectBaseInfo,
});

export default connect(mapStateToProps)(ContactUsLayout);
